(() => {
  function clean(root = document) {
    const scopes = root.querySelectorAll?.('cart-drawer, cart-items, main-cart-items, .cart-item, [id^="CartDrawer-Item"], tr.cart-item') || [];

    scopes.forEach(scope => {
      const text = (scope.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/Couleur 1\s*:/.test(text)) return;

      const options = Array.from(scope.querySelectorAll('.product-option'));

      options.forEach((el, index) => {
        const t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        const isSelectedColor = /^Couleur\s+[1-5]\s*:/.test(t);
        const isKitComposition = /^Composition du kit\s*:/.test(t);
        const isTechnicalVariantLabel = /^Couleur\s*:/.test(t) && !isSelectedColor;
        const isTechnicalVariantValue = index === 0 && !isSelectedColor && !/^Couleur\s+[1-5]\s*:/.test(t);

        if (isKitComposition || isTechnicalVariantLabel || isTechnicalVariantValue) {
          el.style.display = 'none';
        }
      });
    });
  }

  const run = () => clean(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();

  new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) clean(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();